import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
} from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { ReactComponent as HelmetSvg } from '../../assets/helmet.svg'
import { ReactComponent as AddSvg } from '../../assets/add_reverse.svg'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import { SessionContextStore } from '../../context/SessionContext'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import { BackButton } from '../Core/Buttons/BackButton'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import { OperatorForm } from '../Operators/OperatorForm'
import { OperatorBlockView } from '../Operators/OperatorBlockView'
import operatorsApi from '../../api/operators.api'
import { BlueGrayBox } from '../Core/BlueGrayBox'
import CloseIcon from '@material-ui/icons/Close'
import { ActionPaper } from '../Core/Frames/ActionPaper'
import { isMobile } from 'react-device-detect'
import { reportGTM } from '../Core/Utilities/GTagManger'
import { stateWithLimitToOneOperator } from '../../Constants'

export const CustomizeOperators = () => {
  const sessionContext = React.useContext(SessionContextStore)
  const [error, setError] = React.useState('')
  const [operatorEditState, setOperatorState] = React.useState({ operator: {}, open: false, special: false })
  const [open, setOpen] = React.useState(false)
  const state = sessionContext.user.administrativeDivision

  const SaveOrEdit = async operator => {
    if (operator.id == undefined) {
      let res = await awaitWithLoading(operatorsApi.addOperator(operator))
      if (res.ok) {
        await awaitWithLoading(sessionContext.loadUser())
        setOperatorState({ operator: {}, open: false, special: false })
        setError('')
        reportGTM('', '', { event: 'driver-added-success' })
      } else {
        await awaitWithLoading(sessionContext.loadUser())
        setOperatorState({ operator: {}, open: false, special: false })
        EventEmitterService.dispatch(EventKey.ShowError, res)
      }
    } else {
      let res = await awaitWithLoading(operatorsApi.updateOperator(operator))
      if (res.ok) {
        await awaitWithLoading(sessionContext.loadUser())
        setOperatorState({ operator: {}, open: false, special: false })
        setError('')
      } else EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const onContinue = async () => {
    if (!sessionContext.user.userVehicles.every(x => x.new_vehicle_req_details == '' || x.new_vehicle_req_details == null)) {
      setOpen(true)
      return
    }

    if (sessionContext.user.userInsuredPersons.length == 0) {
      setError('Must add at least one rider')
      return
    } else if (sessionContext.doOrphanVehiclesExist()) {
      setError('Make sure all vehicles have an operator')
      return
    } else {
      setError('')
      let res = await awaitWithLoading(operatorsApi.operatorsDetailsNext())
      if (res.ok) {
        EventEmitterService.dispatch(EventKey.FLOW_CUSTOMIZE_OPERATORS_FINISH)
      } else {
        EventEmitterService.dispatch(EventKey.ShowError, res)
      }
    }
  }

  const handleAgree = async () => {
    setOpen(false)
  }

  const handleDisagree = () => {
    setOpen(false)
  }

  const addAnother = () => {
    // setNewForms([...newForms, {}])
    if (sessionContext.user.userInsuredPersons.length == 0) {
      setOperatorState({
        open: true,
        special: true,
        operator: {
          first_name: sessionContext.user.firstName,
          last_name: sessionContext.user.lastName,
          date_of_birth: sessionContext.user.dateOfBirth,
        },
      })
    } else {
      setOperatorState({
        open: true,
        special: false,
        operator: {},
      })
    }
  }
  React.useEffect(() => {
    if (sessionContext.user.userInsuredPersons.length === 0) addAnother()
  }, [])

  const onDeleteOperator = async id => {
    let res = await awaitWithLoading(operatorsApi.deleteOperator(id))
    if (res.ok) {
      await awaitWithLoading(sessionContext.loadUser())
    } else EventEmitterService.dispatch(EventKey.ShowError, res)
  }

  React.useEffect(() => {
    if (sessionContext.user.userInsuredPersons.length > 0 && error == 'Must add at least one rider') setError('')
  }, [sessionContext.user.userInsuredPersons])

  return (
    <>
      <Container>
        <FlexView column>
          <FlexView vAlignContent={'center'}>
            <HelmetSvg className="margin-right-6 medium-icon" />
            <div className="text-title blue bold">Rider Details</div>
          </FlexView>

          {isMobile ? <div className="margin-bottom-basic" /> : <Divider />}

          {sessionContext.user.userInsuredPersons.map((operator, index) => (
            <div key={index} className="capitalize">
              <ActionPaper
                deletable
                onDelete={() => onDeleteOperator(operator.id)}
                onView={() => setOperatorState({ open: true, special: false, operator: operator })}
              >
                <OperatorBlockView firstName={operator.first_name} lastName={operator.last_name} />
              </ActionPaper>
              <br />
            </div>
          ))}
          {(!stateWithLimitToOneOperator.includes(state) ||
            (stateWithLimitToOneOperator.includes(state) && sessionContext.user.userInsuredPersons.length == 0)) && (
            <BlueGrayBox className="fit-content">
              <FlexView vAlignContent={'center'} className="clickable fit-content" onClick={addAnother}>
                <AddSvg />
                <div className="text-body blue margin-left-6">
                  Add {sessionContext.user.userInsuredPersons.length == 0 ? 'a' : 'another'} rider to your insurance
                </div>
              </FlexView>
            </BlueGrayBox>
          )}
          <br />
          {error && <div className="text-body margin-bottom-small red">{error}</div>}
          <FlexView>
            <BackButton />
            <ContinueButton className="margin-left-6" onClick={onContinue} />
          </FlexView>
        </FlexView>

        <Dialog fullScreen fullWidth open={operatorEditState.open}>
          <Container>
            <FlexView className="full-width" hAlignContent={'right'}>
              <IconButton onClick={() => setOperatorState({ operator: {}, open: false, special: false })}>
                <CloseIcon />
              </IconButton>
            </FlexView>
            <br />
            <OperatorForm
              special={operatorEditState.special}
              SAVE_EVENT_KEY="on_health_statement_save"
              defaultValues={operatorEditState.operator}
              onSave={SaveOrEdit}
              motorcycles={sessionContext.user.userVehicles}
            />
          </Container>
        </Dialog>

        <Dialog open={open} onClose={handleDisagree} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">Your bike is one of a kind!</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" className="other-bike-alert-description">
            You've submitted a motorcycle review request, and a VOOM specialist will assess it. If VOOM can support your requested motorcycle, you will receive an updated quote. Due to the unique nature of your bike, we may not be able to reply directly about this issue. For further assistance, feel free to write to:
              <a href="mailto:support@voominsurance.com"> support@voominsurance.com</a>.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <Button onClick={handleDisagree} color="primary">
                    Cancel and return
                </Button> */}
            <Button onClick={handleAgree} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  )
}
